import s from './Header.scss'
import { KeyValuePairs } from 'components/ideal-core-ui'
import DatePicker from 'react-datepicker'
import { Col, Row } from 'reactstrap'
import Select from 'react-select'
import { Link } from 'react-router-dom'
import { FaRedo, FaCertificate } from 'react-icons/fa'
import { timezoneDate, utcDate } from 'utils/helpers'
import moment from 'moment-timezone'
import { getDateFormat } from 'utils/authService'

const Header = ({
  client,
  index,
  changeClientProperty,
  date,
  followUpDate,
  refreshClientContacts,
  cy,
  withDates,
  awardedCompany,
  withInvitedToBid
}) => (
  <>
    <Row>
      <Col lg={withDates ? '2' : '3'} xs="12" sm="12">
        <KeyValuePairs
          pairs={[
            {
              key: (
                <>
                  {awardedCompany?.value === client.value && (
                    <FaCertificate className={s.awardIcon} title="Opportunity Awarded" />
                  )}
                  <Link target="_blank" to={`/companies/${client.value}`}>
                    {client.label}
                  </Link>
                </>
              ),
              keyClass: [s.clientLabel],
              value: null
            }
          ]}
        />
      </Col>
      {withDates && (
        <>
          <Col lg="3" xs="12" sm="12">
            <KeyValuePairs
              pairs={[
                {
                  key: 'Bid Due',
                  keyClass: [s.dateLabel],
                  value: (
                    <DatePicker
                      calendarClassName={s.calendar}
                      selected={moment(
                        timezoneDate(date, 'HH:mm:ss'),
                        `${getDateFormat()} HH:mm:ss`
                      ).toDate()}
                      startDate={moment(
                        timezoneDate(date, 'HH:mm:ss'),
                        `${getDateFormat()} HH:mm:ss`
                      ).toDate()}
                      onChange={value => {
                        const date = value && value !== null ? utcDate(value) : ''
                        changeClientProperty(date, 'dueDate', client.value)
                      }}
                      showTimeSelect
                      timeFormat="h:mm aa"
                      timeIntervals={15}
                      dateFormat={`${getDateFormat()
                        .replace('YYYY', 'yyyy')
                        .replace('DD', 'dd')} h:mm aa`}
                      timeCaption="time"
                      placeholderText="Select client due date"
                    />
                  )
                }
              ]}
            />
          </Col>
          <Col lg="4" xs="12" sm="12">
            <KeyValuePairs
              pairs={[
                {
                  key: 'Follow-up',
                  keyClass: [s.dateLabel],
                  value: (
                    <DatePicker
                      selected={
                        followUpDate
                          ? moment(timezoneDate(followUpDate), getDateFormat()).toDate()
                          : null
                      }
                      onChange={value => {
                        const date = value && value !== null ? utcDate(value) : ''
                        changeClientProperty(date, 'followUpDate', client.value)
                      }}
                      timeIntervals={15}
                      dateFormat={`${getDateFormat().replace('YYYY', 'yyyy').replace('DD', 'dd')}`}
                      timeCaption="time"
                      placeholderText="Client follow up date"
                    />
                  )
                }
              ]}
            />
          </Col>
        </>
      )}
      <Col lg={withDates ? '3' : '7'} xs="12" sm="12">
        <KeyValuePairs
          pairs={[
            {
              key: 'Contact(s)',
              keyClass: [s.contactsLabel],
              value: (
                <>
                  <Select
                    value={client.selectedContacts}
                    onChange={value =>
                      changeClientProperty(value, 'selectedContacts', client.value)
                    }
                    options={client.contacts}
                    isMulti
                    id={cy}
                  />
                  {refreshClientContacts && (
                    <FaRedo
                      data-cy={`refresh-contacts-list-${index}`}
                      className={s.refresh}
                      onClick={() => refreshClientContacts(client.value)}
                    />
                  )}
                </>
              )
            }
          ]}
        />
      </Col>
    </Row>
    {withInvitedToBid && (
      <Row>
        <Col lg={{ size: '4', offset: withDates ? '2' : '3' }} xs="12" sm="12">
          <KeyValuePairs
            pairs={[
              {
                key: 'Invited to bid?',
                keyClass: [s.dateLabel],
                value: (
                  <Select
                    value={
                      client.invitedToBid !== null
                        ? {
                            value: client.invitedToBid,
                            label: client.invitedToBid ? 'Yes' : 'No'
                          }
                        : null
                    }
                    onChange={value =>
                      changeClientProperty(value.value, 'invitedToBid', client.value)
                    }
                    options={[
                      { value: true, label: 'Yes' },
                      { value: false, label: 'No' }
                    ]}
                  />
                )
              }
            ]}
          />
        </Col>
        <Col lg="4" xs="12" sm="12">
          <KeyValuePairs
            pairs={[
              {
                key: 'Listed with this client?',
                keyClass: [s.dateLabel],
                value: (
                  <Select
                    value={
                      client.listedWithThisClient !== null
                        ? {
                            value: client.listedWithThisClient,
                            label: client.listedWithThisClient ? 'Yes' : 'No'
                          }
                        : null
                    }
                    onChange={value =>
                      changeClientProperty(value.value, 'listedWithThisClient', client.value)
                    }
                    options={[
                      { value: true, label: 'Yes' },
                      { value: false, label: 'No' }
                    ]}
                  />
                )
              }
            ]}
          />
        </Col>
      </Row>
    )}
  </>
)

export default Header
